import React from "react";
import "./Vip_Rules.css";
import Rules_card from "../../../Common/Common_Component/Rules_card/Rules_card";

function Vip_Rules() {
  return (
    <>
      <section className="Vip_Rules">
        <div
          className="desc_text_hodler"
          style={{ textAlign: "left", marginBottom: "15px" }}
        >
          <h4>VIP privileges</h4>
          <p>VIP rule description</p>
        </div>

        {/* List of Rules Cards */}
        {[1, 2, 3, 4, 5].map((item) => (
          <Rules_card key={item} />
        ))}
      </section>
    </>
  );
}

export default Vip_Rules;
